module.exports = __webpack_public_path__ + "img/auditlog.ca38a167.svg";